import SmsRowArea from "./sms_row";

function SmsListArea(props:any){
   let myProps={
    sms_data_arr:[],
    set_sms_data_arr:(inData:any)=>{},
    check_row_num_arr:[],
    set_check_row_num_arr:(inData:any)=>{},
    ...props
  };
  
  const get_sms_row_tags=()=>{
    let sms_row_tags=[];
    for(let i=0;i<myProps.sms_data_arr.length;i++){
      let sms_data=myProps.sms_data_arr[i];
      
      let sms_row_tag=(
        <SmsRowArea key={i} 
          sms_data={sms_data}
          row_num={i}
          sms_data_arr={myProps.sms_data_arr}
          set_sms_data_arr={myProps.set_sms_data_arr}
          check_row_num_arr={myProps.check_row_num_arr}
          set_check_row_num_arr={myProps.set_check_row_num_arr}
        />
      );
      sms_row_tags.push(sms_row_tag);
    }
    return sms_row_tags;
  };
  
  return (
  <div>
    {get_sms_row_tags()}
  </div>
  );
};
export default SmsListArea;